import {sendForgotPassword, sendResetPassword} from "../../actions/session";
import LoginForm from "../login/loginForm";
import Input from "../../components/common/input";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import {PASSWORD_REQUIREMENTS} from "../../constants";

const ResetPasswordForm = (props) => {
  const {
    token
  } = props;

  const dispatch = useDispatch();
  const errors = useSelector((state) => state.session.resetPasswordErrors);
  const shouldLockForm = false;

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const onSubmit = () => {
    dispatch(sendResetPassword(password, confirmPassword, token));
  }

  return (
    <LoginForm
      title="Set Password"
      subtitle={PASSWORD_REQUIREMENTS}
      submitLabel="Submit"
      submitAction={() => onSubmit()}
      disabled={shouldLockForm}
    >
      <Input
        name='password'
        id='password'
        label='Password'
        type='password'
        value={password}
        changeAction={setPassword}
        disabled={shouldLockForm}
        errors={errors?.password}
        focusOnError={errors?.password}
      />
      <Input
        name='confirmPassword'
        id='confirmPassword'
        label='Confirm Password'
        type='password'
        value={confirmPassword}
        changeAction={setConfirmPassword}
        disabled={shouldLockForm}
        errors={errors?.confirmPassword}
        focusOnError={errors?.confirmPassword}
      />
    </LoginForm>
    );
}

export default ResetPasswordForm;